import { Link } from 'react-router-dom';

export default function Error403() {
  return (
    <>
      <title>Adgang nægtet - Nygaards Vinduespolering</title>
      <meta name="description" content="Fejl 403 - Adgang nægtet hos Nygaards Vinduespolering." />

      <section className="flex min-h-[70vh] items-center justify-center bg-white px-4 py-16 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Ikon */}
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-red-50 text-red-500">
            <i className="fa-duotone fa-lock-keyhole text-4xl" />
          </div>

          <p className="mt-6 text-sm font-bold uppercase tracking-widest text-red-500">
            Fejl 403
          </p>
          <h1 className="mt-2 font-display text-4xl font-extrabold tracking-tight text-brand-dark sm:text-5xl">
            Adgang nægtet
          </h1>
          <p className="mx-auto mt-4 max-w-md text-base text-slate-500">
            Du har ikke tilladelse til at tilgå denne side. Hvis du mener, dette er en fejl, er du velkommen til at kontakte os.
          </p>

          {/* Navigation links */}
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <Link
              to="/"
              className="rounded-xl bg-brand-blue px-6 py-3 font-display text-sm font-bold text-white shadow-md hover:bg-brand-orange transition-colors"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/ydelser"
              className="rounded-xl border border-slate-200 bg-white px-6 py-3 font-display text-sm font-bold text-slate-700 hover:bg-slate-50 transition-colors"
            >
              Se vores ydelser
            </Link>
            <Link
              to="/kontakt"
              className="rounded-xl border border-slate-200 bg-white px-6 py-3 font-display text-sm font-bold text-slate-700 hover:bg-slate-50 transition-colors"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
